import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {tap, catchError} from "rxjs/operators";
import {of, Subscription} from "rxjs";
import {CacheService} from "../modules/shared/services/cache.service";
import {environment} from "src/environments/environment";
import {AppUpdateService} from "./appUpdate.service";

@Injectable({
  providedIn: "root",
})
export class TranslationUpdaterService {
  private version: string = "0";
  private readonly subscriptions: Subscription[] = [];
  private readonly translationsVersion: string =
    environment.translationsVersion ?? "0";

  constructor(
    private readonly translate: TranslateService,
    private readonly http: HttpClient,
    private readonly cacheService: CacheService,
    private readonly appUpdateService: AppUpdateService
  ) {
    this.init();
  }

  init(): void {
    this.cacheService.getFromCache("app_version").then((cachedAppVersion) => {
      this.version = (cachedAppVersion as string) ?? "0";
    });

    this.subscriptions.push(
      this.appUpdateService.appVersion$.subscribe((response) => {
        if (response) {
          this.version = response.version;
        }
      })
    );

    this.translate.onLangChange.subscribe((event) => {
      this.updateTranslations(event.lang);
    });
  }

  private updateTranslations(lang: string): void {
    const url = this.buildTranslationUrl(lang);
    this.http
      .get(url)
      .pipe(
        tap((translations) => {
          this.cacheService
            .clearCacheByPrefix(["translations_"])
            .catch((err) => console.error("Cache clear failed:", err));
          this.cacheService
            .addToCache(this.buildCacheKey(lang), translations, 40320)
            .catch((err) => console.error("Cache write failed:", err));
          this.translate.setTranslation(lang, translations, false);
        }),
        catchError((error) => {
          console.error("Error during update :", error);
          return of(null);
        })
      )
      .subscribe();
  }

  private buildCacheKey(lang: string): string {
    return `translations_${lang}?v=${this.version}&t=${this.translationsVersion}`;
  }

  private buildTranslationUrl(lang: string): string {
    return `/assets/i18n/${lang}.json?v=${this.version}&t=${this.translationsVersion}`;
  }
}
